import {
  VisitLog,
  PaginatedListResponse,
  APIErrorResponse,
  SearchRequestParams,
} from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'
import { QUERY_KEYS } from '@/constants'

export type VisitLogsSearchParams = SearchRequestParams & {
  id?: string
  date?: string
  startDate?: string
  endDate?: string
  visitResearchers?: string
  project_leader?: string
  assigned_manager?: string
  isEventApproved?: boolean
  is_field_report_approved_by_ai?: boolean
  all_observation_logs_approved?: boolean
  status?: string
  task_status?: string
}

export const getUseVisitLogsKey = (): string[] =>
  QUERY_KEYS.VISIT_LOGS.slice(0, 2) as string[]

export const useVisitLogs = (
  { ...params }: VisitLogsSearchParams,
  enabled = true
): UseQueryResult<PaginatedListResponse<VisitLog>, APIErrorResponse> =>
  useQueryList({
    url: '/plannings/visit_logs/',
    options: {
      enabled,
    },
    params: {
      ...(!!params.id && {
        id: params.id,
      }),
      ...(!!params.search && {
        search: params.search,
      }),
      ...(!!params.status && {
        status: params.status,
      }),
      ...(!!params.task_status && {
        task_status: params.task_status,
      }),
      ...(!!params.startDate && { date_start: params.startDate }),
      ...(!!params.endDate && { date_end: params.endDate }),
      ...(!!params.visitResearchers && {
        researchers: params.visitResearchers,
      }),
      ...(!!params.project_leader && { project_leader: params.project_leader }),
      ...(!!params.assigned_manager && {
        assigned_manager: params.assigned_manager,
      }),
      ...(params.isEventApproved !== undefined && {
        is_event_approved: params.isEventApproved,
      }),
      ...(params.is_field_report_approved_by_ai !== undefined && {
        is_field_report_approved_by_ai: params.is_field_report_approved_by_ai,
      }),
      ...(params.all_observation_logs_approved !== undefined && {
        all_observation_logs_approved: params.all_observation_logs_approved,
      }),
      limit: params.limit,
      offset: params.offset,
    },
  })
